import { isSameDay } from "date-fns";

export const findSameDayReminder = <T extends { date: Date }>(
	reminders: T[],
	date: Date,
): T | null =>
	reminders.find((reminder) => isSameDay(reminder.date, date)) ?? null;
